import { useState, useContext } from "react";
import "./Navbar.css";
import { AuthContext , services } from "../util/api";

export default function Navbar() {
  const { theme, changetheme } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);


  return (
    <>
      {/* NAVBAR */}
      <header className={`nav ${theme}`}>
        {/* <div className="nav-logo">Centernut</div> */}

        <nav className="nav-links">
          {services.map((service) => (
            <a
              key={service.title}
              href={service.link}
              className="service-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="service-icon">{service.icon}</span>
              <span className="service-title">{service.title}</span>
            </a>
          ))}
        </nav>

        <div className="nav-actions">
         {/*  <button
            className="theme-toggle"
            onClick={() => changetheme(theme === "dark" ? "light" : "dark")}
          >
            {theme === "dark" ? "☀️" : "🌙"}
          </button> */}

          <div
            className={`menu-toggle ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div style={{ zIndex: 323292839 }} className={`mobile-menu ${theme}`}>
          {services.map((service) => (
            <a
              key={service.title}
              href={service.link}
              className="service-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMenuOpen(false)}
            >
              <span className="service-icon">{service.icon}</span>
              <span className="service-title">{service.title}</span>
            </a>
          ))}
        </div>
      )}

      {/* PAGE SPACER */}
      <div className="page-wrapper" />
    </>
  );
}